var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.6665H11.8333C9.16667 1.6665 7.5 3.33317 7.5 5.99984V9.37484H12.7083C13.05 9.37484 13.3333 9.65817 13.3333 9.99984C13.3333 10.3415 13.05 10.6248 12.7083 10.6248H7.5V13.9998C7.5 16.6665 9.16667 18.3332 11.8333 18.3332H13.9917C16.6583 18.3332 18.325 16.6665 18.325 13.9998V5.99984C18.3333 3.33317 16.6667 1.6665 14 1.6665Z",
    fill: "#E5633E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79922 9.37503L5.52422 7.65003C5.64922 7.52503 5.70755 7.3667 5.70755 7.20837C5.70755 7.05003 5.64922 6.88337 5.52422 6.7667C5.28255 6.52503 4.88255 6.52503 4.64089 6.7667L1.84922 9.55837C1.60755 9.80003 1.60755 10.2 1.84922 10.4417L4.64089 13.2334C4.88255 13.475 5.28255 13.475 5.52422 13.2334C5.76589 12.9917 5.76589 12.5917 5.52422 12.35L3.79922 10.625H7.49922V9.37503H3.79922Z",
    fill: "#E5633E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoLogout);
export default __webpack_public_path__ + "static/media/trvto_logout.bbf9b4782d74b9faaf2cecaaa0a2f3a3.svg";
export { ForwardRef as ReactComponent };